import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import axios from 'axios';
import 'react-tooltip/dist/react-tooltip.css'

import './index.css';
import reportWebVitals from './reportWebVitals';
import { client } from './service/graphql/graphql';
import { linkLabels, router } from './service/utils/constants';
import { initMatomo, trackPageView } from './service/matomo';

console.log('[BYWATERS] A version:', axios.VERSION || 'unknown');

// Page views are tracked from the router itself, as no single component stays mounted across all routes
const trackRoute = (pathname: string) => {
  // "/" only shows the loading logo before redirecting
  if (pathname === '/') return;
  const label = linkLabels.find((link) => link.path === pathname);
  trackPageView(pathname, label ? label.name : pathname);
};

initMatomo();
trackRoute(router.state.location.pathname);
router.subscribe((state) => trackRoute(state.location.pathname));

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <RouterProvider router={router} />
    </ApolloProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
